import { lazy, PureComponent, Suspense } from 'react';

import { type RouteComponentProps } from 'react-router'

export const WELCOME_PAGE_BASE_URL = '/welcome'

const WelcomeChunk = lazy(() =>
  import('../containers/WelcomeView').then(({ WelcomeView }) => ({
    default: WelcomeView,
  }))
)

export class WelcomePage extends PureComponent<RouteComponentProps> {
  render() {
    return (
      <Suspense fallback={null}>
        <WelcomeChunk {...this.props} />
      </Suspense>
    );
  }
}
